import * as v from 'valibot';
import { integerInRange, dateStringSchema } from '../util/valibot';
export const hastaReceiverCodeSchema = v.object({
    code: integerInRange(0, 0x3ffffff),
    unit: integerInRange(0, 15),
});
export const hastaReceiverSchema = v.object({
    id: integerInRange(0, 0xffffffff),
    title: v.string(),
    codes: v.array(hastaReceiverCodeSchema),
    comment: v.string(),
    created: dateStringSchema,
});
